import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import FormPrompt from "../DailogBoxes/formprompt";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddCategory from "./addcategory";
import { setcategory } from "../../actions/setcategoryaction";

import "./categorylist.css";

const CategoryList = (props) => {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sortBy, setSortBy] = useState("name-asc");
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onFetchData();
    }
    return () => {
      isSubscribed = false;
    };
  }, []);

  const onFetchData = async () => {
    setIsLoadMoreData(true);
    const fetchedDataList = await Service.getAllData("category");
    setCategoryList(fetchedDataList);
    setIsLoadMoreData(false);
    setIsLoading(false);
  };

  const handleToggleActive = async (categoryUid, currentStatus) => {
    const newStatus = !currentStatus;
    const res = await Service.updateData(
      { isActive: newStatus },
      "category",
      categoryUid
    );
    if (res === "success") {
      setCategoryList((prev) =>
        prev.map((c) =>
          c.category_uid === categoryUid ? { ...c, isActive: newStatus } : c
        )
      );
    }
  };
  const handleOnDelete = (CategoryName, uid) => {
    setSelectedCategoryName(CategoryName);
    setSelectedCategoryId(uid);
    setOpenConfirmDailog(true);
  };
  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("category", selectedCategoryId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      window.location.reload(false);
    } else {
      setIsDeleting(false);
      handleErrorDailog();
    }
  };
  const handleSearch = async () => {
    if (searchText === "" || null) {
      window.location.reload(false);
    } else {
      setIsSearching(true);

      const searchTextLower = searchText.toLowerCase().replace(/\s/g, "");

      const resultCategoryList = await Service.getSearchRes(
        "category",
        searchTextLower
      );
      if (resultCategoryList === "error") {
        setIsSearching(false);
        setOpenErrorDailog(true);
      } else {
        setCategoryList(resultCategoryList);
        setIsSearching(false);
      }
    }
  };

  const handleSort = (e) => {
    const sortOption = e.target.value;
    setSortBy(sortOption);

    let sortedList = [...categoryList];

    switch (sortOption) {
      case "name-asc":
        sortedList.sort((a, b) => {
          const aName = (a.name || "").toLowerCase();
          const bName = (b.name || "").toLowerCase();
          return aName.localeCompare(bName);
        });
        break;
      case "name-desc":
        sortedList.sort((a, b) => {
          const aName = (a.name || "").toLowerCase();
          const bName = (b.name || "").toLowerCase();
          return bName.localeCompare(aName);
        });
        break;
      case "date-newest":
        sortedList.sort((a, b) => {
          const aTime = a.timeStamp ? a.timeStamp.toDate?.().getTime?.() || 0 : 0;
          const bTime = b.timeStamp ? b.timeStamp.toDate?.().getTime?.() || 0 : 0;
          return bTime - aTime;
        });
        break;
      case "date-oldest":
        sortedList.sort((a, b) => {
          const aTime = a.timeStamp ? a.timeStamp.toDate?.().getTime?.() || 0 : 0;
          const bTime = b.timeStamp ? b.timeStamp.toDate?.().getTime?.() || 0 : 0;
          return aTime - bTime;
        });
        break;
      default:
        break;
    }

    setCategoryList(sortedList);
  };

  const handleSuccessDailog = () => {
    setOpenAlertDailog(true);
    setOpenFormDailog(false);
  };
  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(false);
  };
  const closeFormDailog = () => {
    setOpenFormDailog(false);
  };
  const closeAlertDailog = () => {
    setOpenAlertDailog(false);
    window.location.reload(false);
  };
  const closeErrorDailog = () => {
    setOpenErrorDailog(false);
  };
  const closeConfirmDailog = () => {
    setOpenConfirmDailog(false);
  };
  const setCloseBtnAppear = () => {
    setIsCloseBtnAppear(false);
  };

  let count = 0;
  return isLoading ? (
    <div className="categoryListPage">
      <i className="fas fa-spinner fa-pulse fa-2x "></i>
    </div>
  ) : (
    <div className="categoryListPage">
      <div className="mainSection">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={closeConfirmDailog}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={`Are you sure to delete ${selectedCategoryName} details`}
        ></ConfirmDialogBox>
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={closeAlertDailog}
          title="Added"
          des="New Category has been added successfully"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={closeErrorDailog}
          title="Error"
          des="Something went wrong. Try again"
        ></ErorrDialogBox>

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New Category"
          onSetOpenDailog={closeFormDailog}
          isCloseBtnAppear={isCloseBtnAppear}
        >
          <AddCategory
            setCloseBtnAppear={setCloseBtnAppear}
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
            collectionName="category"
            id="category_uid"
          ></AddCategory>
        </FormPrompt>

        <div className="topHeader">
          <ul>
            <li>
              <i
                className="fa fa-arrow-circle-o-right fa-2x"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              <h5>Category</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="topSection">
          <div className="wrap">
            <ul>
              <li>
                <div className="search">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Search Category by  name"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />

                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="searchButton"
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </li>
              <li style={{ fontSize: "12px" }}> #</li>
              <li style={{ fontSize: "12px" }}>{categoryList.length} </li>
              <li style={{ marginLeft: "20px" }}>
                <select
                  value={sortBy}
                  onChange={handleSort}
                  className="form-control"
                  style={{ width: "200px" }}
                >
                  <option value="name-asc">Sort by Name (A-Z)</option>
                  <option value="name-desc">Sort by Name (Z-A)</option>
                  <option value="date-newest">Sort by Date (Newest)</option>
                  <option value="date-oldest">Sort by Date (Oldest)</option>
                </select>
              </li>
            </ul>
          </div>
          {/* <Link to="addcategory">
                            <button
                             
                              type="button"
                              className="btn btn-warning"
                            >
                             + Add Category
                            </button>
                          </Link> */}
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              setOpenFormDailog(true);
            }}
          >
            + Add Category
          </button>
        </div>
        <table className="table table-striped">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Icon</th>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          {isSearching ? (
            <i className="fas fa-spinner fa-pulse fa-2x "></i>
          ) : categoryList.length === 0 ? (
            <tbody>
              <tr>
                <td>No Category Found</td>
              </tr>
            </tbody>
          ) : (
            <tbody className="tablebody">
              {categoryList &&
                categoryList.map((p) => {
                  count++;
                  // let date = new Date(p.timeStamp.toDate());
                  // const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                  // const createdDate = `${date.getDate()}/${
                  //   date.getMonth() + 1
                  // }/${date.getFullYear()}`;
                  return (
                    <tr key={p.category_uid || p.categoryId}>
                      <td className="align-middle">{count}</td>
                      <td className="align-middle">
                        {p.imageurl === "" ? (
                          <div className="userbg">
                            <i className="fa fa-user fa-2x"></i>
                          </div>
                        ) : (
                          <img className="image" alt="" srcSet={p.imageurl} />
                        )}
                      </td>
                      <td className="align-middle">{p.name}</td>

                      <td className="align-middle">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={p.isActive !== false}
                            onChange={() =>
                              handleToggleActive(p.category_uid, p.isActive !== false)
                            }
                            title={p.isActive !== false ? "Active" : "Inactive"}
                          />
                          <label className="form-check-label">
                            {p.isActive !== false ? "Active" : "Inactive"}
                          </label>
                        </div>
                      </td>

                      <td className="align-middle">
                        <Link to="editcategory">
                          <button
                            onClick={async () => {
                              const sendData = {
                                ...p,
                                collectionName: "category",
                              };

                              props.setOnCategory(sendData);
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit" aria-hidden="true"></i>
                          </button>
                        </Link>

                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => {
                            handleOnDelete(p.name, p.category_uid);
                          }}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>

        <div className="loadMoreDataSection">
          {isLoadMoreData ? (
            <i className="fas fa-spinner fa-pulse fa-2x loadMoreDataSpinner"></i>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    setOnCategory: (p) => {
      dispatch(setcategory(p));
    },
  };
};

export default connect(null, mapDisptachToProps)(CategoryList);
